import { combineReducers } from "@reduxjs/toolkit";
import { authReducer } from "./authReducers";
import { meetingReducer } from "./meetingReducer";
import { userReducer } from "./userReducer";
import { meetingRoomReducer } from "./meetingRoomReducer";
import { minuteReducer } from "./minuteReducer";
import { actionReducer } from "./actionReducer";
import { notificationReducer } from "./notificationReducer";
import { commonReducer } from "./commonReducer";
import { organizationReducer } from "./organizerReducer";
import { activityReducer } from "./emailLogsActivity";

import {adminUserReducer} from "../Admin/reducers/adminUserReducer"
import {adminRegistrationReducer} from "../Admin/reducers/adminRegistrationReducer"
import {adminAuthReducer} from "../Admin/reducers/adminAuthReducer"

export const rootReducer = combineReducers({
  auth: authReducer,
  meeting: meetingReducer,
  user: userReducer,
  meetingRoom: meetingRoomReducer,
  minute: minuteReducer,
  action: actionReducer,
  notification: notificationReducer,
  common: commonReducer,
  organization: organizationReducer,
  emailLog: activityReducer,
     adminuser:adminUserReducer,
  adminRegistration:adminRegistrationReducer,
  adminauth: adminAuthReducer
});
